import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { CHUNK_RELOAD_SESSION_KEY, isChunkLoadError } from '@/lib/lazyWithRetry'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('QBC App Error:', error, info)

    if (isChunkLoadError(error)) {
      try {
        if (!sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
          sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1')
          window.location.reload()
        }
      } catch {
        window.location.reload()
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <h1 className="font-display text-2xl font-bold text-neutral-900">Something went wrong</h1>
          <p className="max-w-md text-neutral-500">Please refresh the page or try again later.</p>
          <Button onClick={() => window.location.reload()}>Refresh Page</Button>
        </div>
      )
    }
    return this.props.children
  }
}
